import axios from 'axios'
import { ResponseCRUD, ResponseObject, ResponseObjectPaginated, AppLaundryModel } from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL

export function getAppLaundry(dto: AppLaundryModel, page: number) {
  return axios.post<ResponseObjectPaginated<AppLaundryModel[]>>(
    `${BASEURL}/order/getAllOrderApp/${page}`,
    dto,
  )
}
export function getAppLaundryById(dto: string | undefined) {
  return axios.get<ResponseObject<AppLaundryModel>>(
    `${BASEURL}/order/getInformationAppById?id=${dto}`,
  )
}

export function createAppLaundry(dto: AppLaundryModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/createOrderApp`, dto)
}

export function getAppLaundryPrint(id: any) {
  return axios.get<any>(`${BASEURL}/order/printOrderApp?ordenId=${id}`, {
    responseType: 'arraybuffer', // Indica a Axios que esperas un arraybuffer en la respuesta
  })
}

export function getSequenceId(id: any) {
  return axios.get<any>(`${BASEURL}/sequence/getSequenceState?sequence=${id}`)
}
